import { BarChart3, Target, type LucideIcon } from 'lucide-react'

export interface NavItem {
  name: string
  href: string
  icon: LucideIcon
}

export interface NavSection {
  name: string
  items: NavItem[]
}

export const navigationConfig: NavSection[] = [
  {
    name: 'GESTÃO',
    items: [
      { name: 'Dashboard', href: '/dashboard', icon: BarChart3 },
      { name: 'Metas e Planilha', href: '/goals', icon: Target },
    ],
  },
]
